import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import { Box } from "@mui/system";
import RefreshIcon from "@mui/icons-material/Refresh";
import BudgetControlGraphSortBy from "./BudgetControlGraphSortBy";

const BudgetControlGraphFilter = () => {
  const handleExportCSV = () => {
    alert("Download clicked");
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mt: spacing.Spacing.md.$value,
          color: colors.GrayLightMode[900].$value,
        }}
      >
        <Box>
          <Typography
            display={"flex"}
            alignItems={"center"}
            flexDirection={"row"}
            gap={1}
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Regular.$value,
            }}
          >
            Sort by: <BudgetControlGraphSortBy />
          </Typography>
          <Typography
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              mt: spacing.Spacing.sm.$value,
            }}
          >
            17 Brands
          </Typography>
        </Box>
        <Box>
          <IconButton color="secondary" size="large" onClick={handleExportCSV}>
            <FileDownloadIcon
              sx={{ color: colors.GrayLightMode[700].$value }}
            />
          </IconButton>
          <IconButton color="secondary" size="large" >
            <RefreshIcon sx={{ color: colors.GrayLightMode[700].$value }} />
          </IconButton>
        </Box>
      </Stack>

      <Stack
        direction="row"
        spacing={1}
        sx={{ alignItems: "center", py: spacing.Spacing.md.$value }}
      >
        <Typography
          sx={{
            color: colors.GrayLightMode[500].$value,
            fontSize: typography.Size.Text.xxs.$value,
            fontWeight: typography.Font_weight.Bold.$value,
          }}
        >
          Budget Overuse
        </Typography>

        <FormControlLabel
          control={
            <Switch
              color="secondary"
              size="small"
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: colors.Brand[600].$value,
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: colors.Brand[600].$value,
                  opacity: 0.5,
                },
                "& .MuiSwitch-track": {
                  backgroundColor: "#D0D5DD",
                  opacity: 1,
                },
              }}
            />
          }
          label=""
        />
      </Stack>
    </>
  );
};

export default BudgetControlGraphFilter;
